import axios from "@/plugins/axios";

// Audit Log module — query services for the /auditlog backend endpoints.
// Access is role-scoped server-side (BPM/BPHPP/ADMIN full; PP/PO own state).
export default class AuditLogServices {
  // filters: { dateFrom, dateTo, userID, modul, activityType, HID, recordId, url, page, perPage }
  async search(filters = {}) {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/auditlog/search`, { params: filters });
    return (res.data && res.data.data) || { total: 0, rows: [] };
  }

  async detail(id) {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/auditlog/detail`, { params: { id } });
    return (res.data && res.data.data) || null;
  }

  async lookups() {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/auditlog/lookups`);
    return (res.data && res.data.data) || { moduls: [], activities: [], users: [] };
  }

  // same filters as search — returns the CSV as a Blob for download
  async exportCsv(filters = {}) {
    const res = await axios.get(`${process.env.VUE_APP_API_URL}/auditlog/export`, {
      params: filters,
      responseType: "blob",
    });
    return res.data;
  }
}
